export var getElementDimension = function getElementDimension(element, dimension) {
  var dimensionValue = element.getBoundingClientRect()[dimension];
  return Math.round(dimensionValue);
};